import React from "react";

import { useDossier } from "@app/contexts/DossierContext";
import moment from 'moment';
import Badge from "@app/components/1_elements/Badge";

/**
 * Display number of days not cover in the dossier year
 */
export default function CspeDaysCover({cspeRecords}) {
    const dossier = useDossier();
    const taxReturn = dossier.tax_return;

    if (!taxReturn)
        return;

    const { fiscal_starting_date, fiscal_closing_date } = taxReturn;

    // Calculate total days during fiscal period
    const fiscalStart = moment(fiscal_starting_date);
    const fiscalEnd = moment(fiscal_closing_date);
    const totalDaysInPeriod = fiscalEnd.diff(fiscalStart, 'days') + 1;

    // Sort cspe records
    const sortedRecords = [...cspeRecords].sort(
        (a, b) => new Date(a.start_date) - new Date(b.start_date)
    );

    // Calculate number of missing days
    let missingDaysCount = 0;
    let currentEnd = fiscalStart.clone().subtract(1, 'day');

    for (const record of sortedRecords) {
        const recordStart = moment(record.start_date);
        const recordEnd = moment(record.end_date);

        
        const daysBefore = recordStart.diff(currentEnd.add(1, 'day'), 'days');
        if (daysBefore > 0) {
            missingDaysCount += daysBefore;
        }

        currentEnd = recordEnd.clone();
    }

    const daysAfter = fiscalEnd.diff(currentEnd.add(1, 'day'), 'days');
    if (daysAfter > 0) {
        missingDaysCount += daysAfter;
    }    

    const totalDaysOk = totalDaysInPeriod - missingDaysCount;
    const ratio = Math.floor(totalDaysOk / totalDaysInPeriod * 100)
    
    return (
        <div className="custom-row success mb-5">
            <div className="d-flex justify-content-between align-items-center">
                <span><b>Couverture du bilan</b></span>    
                <span><Badge label={`${ratio}%`} classProp={"badge-days-cover"}/></span>
            </div>
            <div className="progress" role="progressbar" aria-label="Days cover" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                <div className="progress-bar" style={{width: `${ratio}%`}}></div>
            </div>
            <div>
                <span className="progress-rounded cover"></span>
                <span className="progress-legend">{totalDaysOk} jours vérifiés</span>
                <span className="progress-rounded not-cover"></span>
                <span className="progress-legend">{missingDaysCount} jours manquants</span>
                <span className="progress-legend">Total : {totalDaysInPeriod} jours</span>
            </div>
        </div>
    )
}